<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <router-view @updated="updateConcept"></router-view>

      <div class="card" v-if="['concepts'].indexOf($route.name) > -1">
        <div class="card-header">
          <i class="fa fa-align-justify"></i> Liste des concepts
          <button
            v-if="hasPermission($store.state.user, 'SETTINGS_CONCEPT_WRITE')"
            :disabled="loading"
            type="button"
            class="btn btn-sm btn-primary float-right"
            @click="newConcept = true"
          >
            <i class="fa fa-plus"></i>&nbsp; Ajouter
          </button>
        </div>
        <div class="card-block">
          <div class="alert alert-info text-center" v-if="loading">
            Chargement en cours...
          </div>

          <Tabs v-model="activeTab" v-else>
            <Tab :header="`Actifs (${active.length})`">
              <ConceptsList :concepts="active" @updated="updateConcept" />
            </Tab>
            <Tab :header="`Archives (${archived.length})`">
              <ConceptsList :concepts="archived" @updated="updateConcept" />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>

    <ModalCreateConcept
      v-model="newConcept"
      @created="concepts.unshift($event)"
    />
  </div>
</template>
<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import ConceptsList from "@/components/concept/ConceptsList";
import ModalCreateConcept from "@/components/concept/ModalCreateConcept";

export default {
  components: {
    Tabs,
    Tab,
    ConceptsList,
    ModalCreateConcept,
  },
  data() {
    return {
      concepts: [],
      newConcept: false,
      activeTab: 0,
      loading: true,
    };
  },

  computed: {
    active() {
      return this.concepts.filter((concept) => !concept.archived);
    },

    archived() {
      return this.concepts.filter((concept) => concept.archived);
    },
  },

  async created() {
    try {
      const { data } = await this.$api.get("/concepts");

      this.concepts = data;
    } catch {
      this.$router.push({
        name: "dashboard",
      });
    } finally {
      this.loading = false;
    }
  },

  methods: {
    updateConcept(concept) {
      const index = this.concepts.findIndex((c) => c.name === concept.name);

      if (index > -1) {
        this.concepts.splice(index, 1, concept);
      }
    },
  },
};
</script>
